import { ShareProvider, TabsProvider, WeeklyReportsProvider } from '@/contexts';

const DashboardProviders: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  return (
    <TabsProvider>
      <ShareProvider>
        <WeeklyReportsProvider>{children}</WeeklyReportsProvider>
      </ShareProvider>
    </TabsProvider>
  );
};

export default DashboardProviders;
